import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ManipulateFolderData } from '../../interfaces/manipulate-folder-data.interface';
import {existingNameValidator, forbiddenSymbolsValidator} from '../../../../../core/utils/validators';

@Component({
  selector: 'mee-manipulate-folder',
  templateUrl: './manipulate-folder.component.html',
  styleUrls: ['./manipulate-folder.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManipulateFolderComponent {
  data = inject<ManipulateFolderData>(MAT_DIALOG_DATA);
  nameControl = new FormControl(this.data?.folderName ?? '', [
    Validators.required,
    Validators.maxLength(32),
    forbiddenSymbolsValidator(['\\', '/', ':', '*', '?', '"', '<', '>', '|'], { forbiddenSymbol: true }),
    existingNameValidator(this.data.existingFolderNames ?? []),
  ]);
  dialogRef = inject<MatDialogRef<ManipulateFolderComponent, string>>(MatDialogRef);
}
